<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="activityType"
            label="活动类型"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityTitle"
            label="活动标题"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityStartDate"
            label="活动开始时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityEndDate"
            label="活动结束时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityListPublishedDate"
            label="活动中奖名单公布时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityCreateTime"
            label="活动创建时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="activityAnswerTip"
            label="竞猜答案提示"
            width="180">
    </el-table-column>
    <el-table-column
            prop="isRelease"
            label="是否发布"
            width="180">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">筛选结果</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

  export default {
    name: "marketingMerchantsTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$router.push("/activity/insert/"+id)
      },
      update(id){
        this.$router.push("/guess/List/"+id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
